import { GameFeatureCameraRigProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameFeatureCameraRigProperties";
/**
 * Portrait properties for the camera rigging in the base game.
 */
export class BaseGameCameraRigLandscapeProperties extends GameFeatureCameraRigProperties {
    constructor() {
        super(...arguments);
        this.name = "base-game-camera-rig-landscape";
        this.scatterPickZoomStart = 1.1;
        this.scatterPickZoomEnd = 1.3;
        this.scatterPickShake = 14;
    }
}
export class ChanceGameBackgroundCameraRigLandscapeProperties extends GameFeatureCameraRigProperties {
    constructor() {
        super(...arguments);
        this.name = "chance-game-background-camera-rig-landscape";
        this.scatterPickZoomStart = 0.75;
        this.scatterPickZoomEnd = 1;
        this.scatterPickShake = 12;
    }
}
export class ChanceGameForegroundCameraRigLandscapeProperties extends GameFeatureCameraRigProperties {
    constructor() {
        super(...arguments);
        this.name = "chance-game-foreground-camera-rig-landscape";
        this.scatterPickZoomStart = 0.65;
        this.scatterPickZoomEnd = 1;
        this.scatterPickShake = 20;
    }
}
//# sourceMappingURL=FeatureCameraRigLandscapeProperties.js.map